import { gql } from "@apollo/client";

export const UPLOAD_TEMP_IMAGES = gql`
  mutation ($token: String!, $images: [Upload]!) {
    uploadTempImages(token: $token, images: $images) {
      success
      message
    }
  }
`;
